import { render, staticRenderFns } from "./goods.vue?vue&type=template&id=42bfc326&scoped=true&"
import script from "./goods.vue?vue&type=script&lang=js&"
export * from "./goods.vue?vue&type=script&lang=js&"
import style0 from "./goods.vue?vue&type=style&index=0&id=42bfc326&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42bfc326",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\00_GIT\\hotel\\hotel-front-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42bfc326')) {
      api.createRecord('42bfc326', component.options)
    } else {
      api.reload('42bfc326', component.options)
    }
    module.hot.accept("./goods.vue?vue&type=template&id=42bfc326&scoped=true&", function () {
      api.rerender('42bfc326', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/point_shop/goods.vue"
export default component.exports